// extracted by mini-css-extract-plugin
module.exports = {"Background":"Background_Background__Qinmp","wipe":"Background_wipe__kygAJ","dark":"Background_dark__O2ESs","light":"Background_light__lEcAO"};